export default __webpack_public_path__ + "static/media/umbrellas-tablet.2bc68fa8.jpg";